/**
 * Hero Parallax & Scroll Animations
 * Adds depth and movement to the hero section
 */

class HeroParallax {
  constructor() {
    this.hero = document.querySelector('.hero');
    if (!this.hero) return;

    this.heroMedia = this.hero.querySelector('.hero__media');
    this.heroImage = this.hero.querySelector('.hero__image');
    this.heroHeading = this.hero.querySelector('.hero__heading');
    this.heroSubheading = this.hero.querySelector('.hero__subheading');
    this.heroButtons = this.hero.querySelector('.hero__buttons');

    this.ticking = false;
    this.lastScrollY = window.pageYOffset || window.scrollY;

    this.init();
  }

  init() {
    // Bind scroll event with throttling for performance
    window.addEventListener('scroll', () => this.onScroll(), { passive: true });

    // Initial call
    this.update();
  }

  onScroll() {
    this.lastScrollY = window.pageYOffset || window.scrollY;

    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });

      this.ticking = true;
    }
  }

  update() {
    const scrollY = this.lastScrollY;
    const heroHeight = this.hero.offsetHeight;

    // Only apply parallax when hero is visible
    if (scrollY > heroHeight) {
      // Reset transforms when scrolled past hero
      if (this.heroHeading) {
        this.heroHeading.style.opacity = '0';
      }
      if (this.heroSubheading) {
        this.heroSubheading.style.opacity = '0';
      }
      if (this.heroButtons) {
        this.heroButtons.style.opacity = '0';
      }
      return;
    }

    const scrollPercent = scrollY / heroHeight;

    // Parallax effect on image (slower movement)
    if (this.heroImage) {
      const imageOffset = scrollY * 0.5;
      this.heroImage.style.transform = `translateY(${imageOffset}px) scale(${1 + scrollPercent * 0.1})`;
    }

    // Parallax effect on heading (medium speed)
    if (this.heroHeading) {
      const headingOffset = scrollY * 0.3;
      const headingOpacity = 1 - scrollPercent * 1.2;
      this.heroHeading.style.transform = `translateY(${headingOffset}px)`;
      this.heroHeading.style.opacity = Math.max(0, headingOpacity);
    }

    // Parallax effect on subheading (medium speed)
    if (this.heroSubheading) {
      const subheadingOffset = scrollY * 0.4;
      const subheadingOpacity = 1 - scrollPercent * 1.3;
      this.heroSubheading.style.transform = `translateY(${subheadingOffset}px)`;
      this.heroSubheading.style.opacity = Math.max(0, subheadingOpacity);
    }

    // Parallax effect on buttons (faster speed)
    if (this.heroButtons) {
      const buttonOffset = scrollY * 0.5;
      const buttonOpacity = 1 - scrollPercent * 1.4;
      this.heroButtons.style.transform = `translateY(${buttonOffset}px)`;
      this.heroButtons.style.opacity = Math.max(0, buttonOpacity);
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new HeroParallax();
  });
} else {
  new HeroParallax();
}
